import React from "react";
import { Link } from "react-router-dom";
import {
  // FaFacebookSquare,
  // FaLinkedin,
  // FaTwitterSquare,
  // FaVimeoSquare,
  // FaTumblrSquare,
  FaPhone,
  FaRegEnvelope,
  FaUserAlt,
} from "react-icons/fa";

const MobileWidgets = () => {
  return (
    <div className="offcanvasWidgetArea">
      <div className="offCanvasContactWidget">
        <div className="headerContactInfo">
          <ul className="headerContactInfoList">
            {/* <li>
              <FaUserAlt />{" "}
              <Link to={process.env.PUBLIC_URL + "/login"}>Login </Link>
              <Link to={process.env.PUBLIC_URL + "/register"}>/ Register </Link>
            </li> */}
            <li>
              <FaUserAlt />{" "}
              <a
                href="https://portal.thepips.com/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                Login
              </a>
              <a
                href="https://portal.thepips.com/register"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" | "}Register
              </a>
            </li>
            <li>
              <FaPhone /> <a href="tel://447441429188">+44 7441 429188</a>
            </li>
            <li>
              <FaRegEnvelope />{" "}
              <a href="mailto:support@thepips.com">support@thepips.com</a>
            </li>
          </ul>
        </div>
      </div>
      {/*Off Canvas Widget Social Start*/}
      {/* <div className="offCanvasWidgetSocial">
        <a
          href="//facebook.com"
          target="_blank"
          rel="noopener noreferrer"
          title="Facebook"
        >
          <FaFacebookSquare />
        </a>
        <a
          href="//linkedin.com"
          target="_blank"
          rel="noopener noreferrer"
          title="LinkedIn"
        >
          <FaLinkedin />
        </a>
        <a
          href="//twitter.com"
          target="_blank"
          rel="noopener noreferrer"
          title="Twitter"
        >
          <FaTwitterSquare />
        </a>

        <a href="//vimeo.com" target="_blank" rel="noopener noreferrer" title="Vimeo">
          <FaVimeoSquare />
        </a>

        <a href="//tumblr.com" target="_blank" rel="noopener noreferrer" title="Tumblr"> 
          <FaTumblrSquare />
        </a>
      </div> */}
      {/*Off Canvas Widget Social End*/}
    </div>
  );
};

export default MobileWidgets;
